import type { Router } from '@angular/router';
import type { ProductWithControls } from 'src/typings';

/** Nested outlets can instantiate after NavigationEnd; their state is then in history. */
export function readCartNavigationSelection(
  router: Pick<Router, 'getCurrentNavigation'>,
  historyState: unknown = window.history.state
): ProductWithControls[] | undefined {
  const navigation = router.getCurrentNavigation();
  // An active navigation without selected rows means a new empty document. Never
  // borrow the previous history entry, including when selected is explicitly [].
  const state = navigation ? navigation.extras.state : historyState;
  const selected = state && typeof state === 'object'
    ? (state as { selected?: unknown }).selected : undefined;
  return Array.isArray(selected) ? selected : undefined;
}
